import React from 'react';
import Icon from '../../../icon';

const TagDeleteButton = (props) => {
  const {
    selectProps: { isDisabled },
    innerProps: { ref, ...restInnerProps },
  } = props;

  return (
    <button
      {...restInnerProps}
      ref={ref}
      className="ws-ui-tag-input-tag-delete-button"
      disabled={isDisabled}
    >
      <Icon type="inherit" size="100%" glyph="clear-search" />
    </button>
  );
};

export default TagDeleteButton;
